module.exports = __webpack_public_path__ + "img/mc-fast-forward.473c3eaa.svg";